const ConfirmAutoRelaunchModal = ({
  isOpen,
  count,
  onConfirm,
  onCancel,
  t,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h3>{t("Confirm relaunch")}</h3>

        <p>
          {t("You are about to relaunch {{count}} documents based on current filters.", {
            count,
          })}
        </p>

        <div className="modal-actions">
          <button className="btn_cancel" onClick={onCancel}>
            {t("Cancel")}
          </button>
          <button className="modal-button" onClick={onConfirm}>
            {t("Confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAutoRelaunchModal;
